import { portalEnv } from '../config/portalEnv';

export const TURBOVERSE_BASE_URL = portalEnv.turboverse.baseUrl;
export const TURBOVERSE_SOCKET_URL = portalEnv.turboverse.socketUrl;
export const FIREBASE_VAPID_KEY = portalEnv.vapidKey;

export const STOMP_SEND_MESSAGE_PATH = portalEnv.stomp.sendMessagePath;
export const STOMP_HEARTBEAT_PATH = portalEnv.stomp.heartbeatPath;
